import { toast } from 'sonner';
import { CompanyFormT } from '@/form/company/company.schema';

interface ActivateCompanyParams {
  activation_key: string;
  id: string | number;
  activateCompanyMutation: any;
  setActivatingId: (id: string | number | null) => void;
}

export const handleActivateCompany = async ({
  activation_key,
  id,
  activateCompanyMutation,
  setActivatingId
}: ActivateCompanyParams) => {
  setActivatingId(id);
  try {
    const res = await activateCompanyMutation({ activation_key }).unwrap();
    toast.success(res.message);
  } catch (error: any) {
    console.error('Activation error:', error);
    toast.error(error?.data?.errors || 'Something went wrong');
  } finally {
    setActivatingId(null);
  }
};

interface UpdateCompanyParams {
  id: string | number;
  data: CompanyFormT;
  updateCompanyMutation: any;
  onSuccess: () => void;
}

export const handleUpdateCompany = async ({
  id,
  data,
  updateCompanyMutation,
  onSuccess
}: UpdateCompanyParams) => {
  try {
    const res = await updateCompanyMutation({
      id,
      data: {
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        company_slug: data.company_slug,
        company_registration: data.company_registration,
        registration_comments: data.registration_comments,
        mobile: data.mobile,
        email: data.email,
        contact: data.contact
      }
    }).unwrap();

    toast.success(res?.message || 'Company updated successfully');
    onSuccess();
  } catch (error: any) {
    console.error('Failed to update company:', error);
    toast.error(error?.data?.message || 'Failed to update company');
  }
};

interface DeleteCompanyParams {
  id: string;
  status: 'pending' | 'active';
  deleteCompanyMutation: any;
  setDeletingId: (id: string | number | null) => void;
}

export const handleDeleteCompany = async ({
  id,
  status,
  deleteCompanyMutation,
  setDeletingId
}: DeleteCompanyParams) => {
  setDeletingId(id);
  try {
    const res = await deleteCompanyMutation({ id, status }).unwrap();
    toast.success(res.message || 'Company deleted successfully');
  } catch (error: any) {
    console.error('Delete error:', error);
    toast.error(error?.data?.message || 'Something went wrong');
  } finally {
    setDeletingId(null);
  }
};
